import React from 'react'
import {
  IconButton,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'
import { FaTrash } from 'react-icons/fa'
import { api } from '../../../services/api'
import { useQueryClient } from 'react-query'

export const RemoverNf = ({ id }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const onClose = () => setIsOpen(false)
  const cancelRef = React.useRef()
  const toast = useToast({ position: 'top-right' })
  const queryClient = useQueryClient()

  const handleDelete = async () => {
    try {
      await api.patch(`/site/v2/fiscal/remover-nf/${id}`)

      toast({
        title: 'Nota fiscal removida com sucesso!',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })

      // Invalidar a consulta para atualizar a lista
      queryClient.invalidateQueries('nfData')
      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao remover nota fiscal',
        description: error.response?.data?.message || 'Ocorreu um erro ao remover a nota fiscal.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
      onClose()
    }
  }

  return (
    <>
      <IconButton aria-label="Remover nota fiscal" icon={<FaTrash />} colorScheme="red" variant="ghost" size="sm" onClick={() => setIsOpen(true)} />

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Remover Nota Fiscal
            </AlertDialogHeader>

            <AlertDialogBody>Tem certeza que deseja remover esta nota fiscal? Esta ação não pode ser desfeita.</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Remover
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
